var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg005UnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.298 90.839h-169.008l-16.516 12.828h-49.548l-16.516-12.828h-169.008l-37.202 16.516v304.978h471.167l32.333-20.655v-94.388l-13.25-16.516v-49.548l13.25-16.516v-94.386z",
    fill: "#5055a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 404.645h-384.936c-27.365 0-49.548-22.184-49.548-49.548v-230.097l-16.516-4.676v94.386l9 4.623v72.5l-9 5.458v94.387l45.699 29.483h169.011l16.516-11.286h49.548l16.515 11.286h169.012z",
    fill: "#3f3f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.686 90.89-20.311 4.485-457.302 293.878 30.365 19.654 457.479-295.657 3.936-11.84c-2.258-5.81-7.676-10.053-14.167-10.52z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.287 384.55-25.178 26.058c2.253 5.816 7.704 10.039 14.196 10.509l42.034-17.287c-12.687-2.257-23.674-9.333-31.052-19.28z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 94.25-17.688-3c-9.122 0-13.75 8.737-13.75 17.859v3.141l475.188 305.5 32.25-16.875z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.375 404.645h-50.442l19.755 9.667 21.013 6.805c6.487-.473 11.934-4.691 14.188-10.502z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.271 90.894c-6.448.503-11.914 4.705-14.158 10.49l15.404 19.768v-29.647z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 231.226-222.968-8.258-8.258-132.129h-49.548l-8.258 132.129h-214.718v66.064h214.718v124.301h66.064v-124.301l222.968-8.258z",
    fill: "#e5646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 280.774 16.516 8.258v-66.064l-16.516 8.258z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.774 421.161h-49.548l-8.258-16.516h66.064z",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 280.774h-222.968c-4.561 0-8.258 3.697-8.258 8.258v115.613l7.79 7.79 8.726-7.79v-92.523l143.411 92.522 28.396 8.561 2.069-8.561-166.401-107.353h30.471l166.399 107.354 7.865 3.105 2.5-3.105v-12.967l-146.3-94.388h146.3z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.968 280.774h-206.452l-8.266 8.258 8.266 8.258h129.784l-124.431 80.279-6.119 13.264 16.039-.01 144.975-93.533h30.471l-160.399 103.482 2.289 9.603 22.174-5.73 143.411-92.522v92.522l7.957 7.688 8.559-7.688v-115.613c0-4.561-3.697-8.258-8.258-8.258z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.71 90.839v109.038l-169.008-109.038h-29.186c-.378 0-.874.03-1.246.055l191.966 123.815h-30.473l-160.247-103.384-5.183 7.341 5.183 12.313 129.783 83.73h-129.783l-8.266 8.258 8.266 8.258h206.452c4.561 0 8.258-3.697 8.258-8.258v-132.128z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 214.71h16.516v16.516h-16.516z",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 111.325-15.402-9.941c-.717 1.85-1.114 3.869-1.114 5.971v12.969l16.516 10.655z",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 107.355c0-2.102-.431-4.095-1.148-5.945l-175.616 113.3h-30.473l191.923-123.82c-.372-.025-.824-.051-1.202-.051h-29.186l-169.008 109.038v-109.038h-16.516v132.129c0 4.56 3.697 8.258 8.258 8.258h222.968v-16.516h-146.299l146.299-94.386z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e1e1e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 280.774h16.516v16.516h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.789 390.824c-3.99-3.829-7.385-8.278-9.92-13.254l-21.869 14.108v12.967c0 2.103.393 4.113 1.109 5.963z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.71 404.645h16.516v16.516h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.774 404.645h16.516v16.516h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.699 421.161 25.6-16.516h-5.234c-6.82 0-13.316-1.381-19.228-3.872l-31.53 20.337c.373.025.831.051 1.21.051z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.774 404.645h16.516v16.516h-16.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.89 410.616c.717-1.85 1.11-3.868 1.11-5.971h-10.365z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.166 404.645h-30.465l25.6 16.516h29.182c.38 0 .843-.024 1.216-.05z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg005UnitedKingdom);
export default __webpack_public_path__ + "static/media/005-united-kingdom.d6d27d9f005e833df8cfcadb87db14b7.svg";
export { ForwardRef as ReactComponent };